import { Box, Dialog, DialogContent, Fade, useMediaQuery } from '@mui/material';
import { forwardRef } from 'react';

import SearchEngine from '@/components/SearchEngine/SearchEngine';

import SearchBox from './SearchBox/SearchBox';

const Transition = forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const Search = ({ open, onClose }) => {
  const mdMediaQuery = useMediaQuery(theme => theme.breakpoints.down('md'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={mdMediaQuery}
      TransitionComponent={Transition}
      transitionDuration={100}
      disableRestoreFocus
      PaperComponent={Box}
      PaperProps={{
        sx: {
          maxWidth: 960,
          width: '100%',
          top: 0,
          alignSelf: 'flex-start',
        },
      }}>
      <DialogContent data-test-subject="search-dialog" sx={{ p: 0 }}>
        <SearchEngine>
          <SearchBox onClose={onClose} />
        </SearchEngine>
      </DialogContent>
    </Dialog>
  );
};

export default Search;
